// Phase-A SEO baseline — one shared component for per-route metadata.
// Uses react-helmet-async (already provided at App root by <HelmetProvider>).
//
// Rules:
//   - Every public page passes a UNIQUE title + description + path.
//   - Canonical is built from path against the production origin
//     https://barterindia.in — the origin Google has selected.
//   - `robots` defaults to "index,follow" for public pages; pass
//     "noindex,follow" for login/private surfaces.
//   - No changefreq / priority / lastmod are surfaced by SEO here — the
//     sitemap.xml is the source of truth for indexing scope.

import { Helmet } from "react-helmet-async";

const CANONICAL_ORIGIN = "https://barterindia.in";

export default function Seo({
  title,
  description,
  path = "/",
  robots = "index,follow",
}) {
  const canonical = path.startsWith("http")
    ? path
    : `${CANONICAL_ORIGIN}${path === "/" ? "/" : path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta name="robots" content={robots} />
    </Helmet>
  );
}
